import React from 'react';

import { Box, Card, Flex, Heading, Text } from '@opendoor/bricks/core';
import { Avatars } from 'sellDirect/routes/lwc/components/shared/OfferCardHeadlineRange';
import { Chip } from 'shared/components/Chip';
import { useDevice } from '@opendoor/bricks/hooks/useMedia';
import { useSupportContacts } from 'sellDirect/helpers/useSupportContacts';
import { CONTACT_PHONE } from 'shared/helpers/globals';

/**
 * Renders the LWC card to show in the Expired Offer Page
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const ExpiredLwcCard: React.FC = () => {
  const { loadingContacts, experiencePartner } = useSupportContacts();
  const { isMobile } = useDevice();

  const avatars = <Avatars size="md" />;
  const phoneNumber = (
    <Chip
      w="fit-content"
      h="fit-content"
      // @ts-expect-error: #EEF4FA, but is intended as a one-off custom color.
      backgroundColor="#EEF4FA"
      color="neutrals100"
      fontWeight="regular"
    >
      {loadingContacts
        ? '...'
        : experiencePartner?.phoneNumber
        ? // After loading, if experience partner has phone number, show it
          experiencePartner.phoneNumber
        : // Default to the CONTACT_PHONE
          CONTACT_PHONE}
    </Chip>
  );

  const text = (
    <Box>
      <Heading as="h3" size="h4">
        Want to try and get a higher offer?
      </Heading>
      <Text>You could get multiple offers on your home by listing with us. </Text>
    </Box>
  );

  return (
    <Card
      variant="primary"
      p={[7, 7, 7]}
      display="flex"
      flexDir="row"
      alignItems="center"
      justifyContent="space-between"
    >
      {isMobile ? (
        <Flex flexDir="column" gridGap="5" w="100%">
          <Flex flexDir="row" alignItems="center" justifyContent="space-between">
            {avatars}
            {phoneNumber}
          </Flex>
          {text}
        </Flex>
      ) : (
        <>
          <Flex flexDir="row" alignItems="center" gridGap="3">
            {avatars}
            {text}
          </Flex>

          <Flex flexDir="column" justifyContent="center" alignItems="flex-end" gridGap="3">
            <Text fontWeight="bold" textAlign="end" minW="170px">
              Call us to learn more
            </Text>
            {phoneNumber}
          </Flex>
        </>
      )}
    </Card>
  );
};
